/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const general = r => require.ensure([], () => r(require('./components/manage/edit/general')), 'setting');
const usermanagement = r => require.ensure([], () => r(require('./components/manage/edit/usermanagement')), 'setting');
const directlearning = r => require.ensure([], () => r(require('./components/manage/edit/directlearning')), 'setting');
const directlearning_recipient = r => require.ensure([], () => r(require('./components/manage/edit/directlearning_recipient')), 'setting');
const campaign = r => require.ensure([], () => r(require('./components/manage/edit/campaign')), 'setting');
const email = r => require.ensure([], () => r(require('./components/manage/edit/email')), 'setting');
const landing = r => require.ensure([], () => r(require('./components/manage/edit/landing')), 'setting');
const adform = r => require.ensure([], () => r(require('./components/manage/edit/adform')), 'setting');
const listad = r => require.ensure([], () => r(require('./components/manage/edit/listad')), 'setting');
const adlogs = r => require.ensure([], () => r(require('./components/manage/edit/adlogs')), 'setting');
const alladlogs = r => require.ensure([], () => r(require('./components/manage/edit/alladlogs')), 'setting');
const oopspage = r => require.ensure([], () => r(require('./components/manage/edit/landing_oops')), 'setting');
//const trainingmail = r => require.ensure([], () => r(require('./components/manage/edit/training_mail')), 'setting');
const trainingmail = r => require.ensure([], () => r(require('./components/manage/edit/reminder_template')), 'setting');
const dl_invitation_mail = r => require.ensure([], () => r(require('./components/manage/edit/dl_invitation_mail')), 'setting');
const dl_login_link_mail = r => require.ensure([], () => r(require('./components/manage/edit/dl_login_link_mail')), 'setting');
const dl_login_with_password_mail = r => require.ensure([], () => r(require('./components/manage/edit/dl_login_with_password_mail')), 'setting');
const security = r => require.ensure([], () => r(require('./components/manage/edit/security')), 'setting');
const azure = r => require.ensure([], () => r(require('./components/manage/edit/azure')), 'setting');
const books = r => require.ensure([], () => r(require('./components/manage/booklist')), 'setting');
//const bookEdit = r => require.ensure([], () => r(require('./components/manage/edit/editbook')), 'setting');
const changepassword = r => require.ensure([], () => r(require('./components/manage/edit/changepassword')), 'setting');
const bulkeducation = r => require.ensure([], () => r(require('./components/manage/bulkeducation/booklist')), 'setting');
const point_configure = r => require.ensure([], () => r(require('./components/manage/edit/point_configure')), 'setting');
const reminder = r => require.ensure([], () => r(require('./components/manage/edit/reminder')), 'setting');
const leaderboardsetting = r => require.ensure([], () => r(require('./components/manage/edit/leaderboardsetting')), 'setting');
const welcome_mail = r => require.ensure([], () => r(require('./components/manage/edit/welcome_mail')), 'setting');
const trainingmodule = r => require.ensure([], () => r(require('./components/manage/edit/trainingmodule')), 'setting');
const master_landing = r => require.ensure([], () => r(require('./components/manage/edit/master_landing')), 'setting');
const reminder_template = r => require.ensure([], () => r(require('./components/manage/edit/reminder_template')), 'setting');
const throttling_sending_speed = r => require.ensure([], () => r(require('./components/manage/throttling_sending_speed')), 'setting');
export default [
 
    {
        name: 'general',
        path: '/setting/general',
        component: general,
    },
    {
        name: 'throttling_sending_speed',
        path: '/setting/throttling_sending_speed',
        component: throttling_sending_speed,
    },
    {
        name: 'master_landing',
        path: '/setting/master_landing',
        component: master_landing,
    },
    {
        name: 'trainingmodule',
        path: '/setting/trainingmodule',
        component: trainingmodule,
    },
    {
        name: 'leaderboardsetting',
        path: '/setting/leaderboardsetting',
        component: leaderboardsetting,
    },
    {
        name: 'usermanagement',
        path: '/setting/usermanagement',
        component: usermanagement,
    },
    {
        name: 'directlearning',
        path: '/setting/directlearning',
        component: directlearning,
    },
    {
        name: 'directlearning_recipient',
       // path: '/setting/directlearning/recipient/:id',
        path: '/setting/directlearning/:id/:type',
        component: directlearning_recipient,
    },
    {
        name: 'retest',
        path: '/setting/campaign',
        component: campaign,
    },
    {
        name: 'email',
        path: '/setting/email',
        component: email,
    },
    {
        name: 'landing',
        path: '/setting/landing',
        component: landing,
    },
    {
        name: 'adform',
        path: '/setting/adform',
        component: adform,
    },
    {
         name: 'listad',
         path: '/setting/listad',
         component: listad,
    },
    {
        name: 'adlogs',
        path: '/setting/adlogs/:id',
        component: adlogs,
    },
    {
        name: 'alladlogs',
        path: '/setting/alladlogs',
        component: alladlogs,
    },
    {
        name: 'oopspage',
        path: '/setting/oopspage',
        component: oopspage,
    },
    {
        name: 'trainingmail',
        path: '/setting/trainingmail',
        component: trainingmail,
    },
    {
        name: 'dl_invitation_mail',
        path: '/setting/dl_invitation_mail',
        component: dl_invitation_mail,
    },
    {
        name: 'dl_login_link_mail',
        path: '/setting/dl_login_link_mail',
        component: dl_login_link_mail,
    },
    {
        name: 'dl_login_link_mail',
        path: '/setting/dl_login_link_mail',
        component: dl_login_link_mail,
    },
    {
        name: 'dl_login_with_password_mail',
        path: '/setting/dl_login_with_password_mail',
        component: dl_login_with_password_mail,
    },
    {
        name: 'security',
        path: '/setting/security',
        component: security,
    },
    {
        name: 'azure',
        path: '/setting/azure',
        component: azure,
    },
    {
        name: 'books',
        path: '/setting/books',
        component: books,
    },
    {
        name: 'changepassword',
        path: '/setting/changepassword',
        component: changepassword,
    },
    {
        name: 'bulkeducation',
        path: '/setting/bulkeducation',
        component: bulkeducation,
    },
    {
        name: 'point_configure',
        path: '/setting/point_configure',
        component: point_configure,
    },
    {
        name: 'reminder',
        path: '/setting/reminder',
        component: reminder,
    },
    {
        name: 'welcome_mail',
        path: '/setting/welcome_mail',
        component: welcome_mail,
    }
]



// WEBPACK FOOTER //
// ./src/app/setting/routes.js